type CrossIconProps = {
  fill?: string
  id?: string
  width?: number
  height?: number
  className?: string
  strokeWidth?: number
}

export const CrossIcon: React.FC<CrossIconProps> = ({
  fill,
  width,
  height,
  id,
  className,
  strokeWidth,
}) => {
  return (
    <div className={'CrossIcon ' + className} id={id}>
      <svg
        width={width || '16'}
        height={height || width || '17'}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0418 2.45837L1.9585 14.5417"
          stroke={fill || '#2E3C49'}
          strokeWidth={strokeWidth || '1.5'}
        />
        <path
          d="M1.9585 2.45837L14.0418 14.5417"
          stroke={fill || '#2E3C49'}
          strokeWidth={strokeWidth || '1.5'}
        />
      </svg>
    </div>
  )
}
